export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PLACE_TYPE_NAME_CHOISE = {
  1: "Hiking Trail",
  2: "Museum",
  3: "Activity",
  4: "Sightseeing",
  5: "Tourist Farm",
  6: "Restaurant",
};

export const PLACE_TYPE_COLOR_CHOISE = {
  1: "#58d78e",
  2: "#f1c40f",
  3: "#ff8e4f",
  4: "#45deff",
  5: "#71ff2e",
  6: "#ff72ad",
};
